import * as React from 'react';
import { MapPathProps } from '../../interface/MapInterface';
import styled from "styled-components";

const GeoPath = styled.path<{ $isClickable: boolean }>`
    cursor:${props => props.$isClickable ? 'pointer' : 'default'};
    &:hover {
        fill:orange;
    }
`;

class Map extends React.Component<MapPathProps> {
    shouldComponentUpdate(np, ns) {
        //only render map once(initial render), otherwise everytime mouse event fires thousands of svg paths gets re-rendered
        if (np.shapeData.features === this.props.shapeData.features) {
            //however, when filter changes the map needs to be updated 
            if (np.tablename !== this.props.tablename) {
                return true;
            }
            return false;
        } else {
            return true;
        }
    }


    fill = (match) => {
        if (this.props.isEmployee) {
            if (!match[0]) return this.props.colorScale(null);
            if (match[0]['fips'] == this.props.stateFips && this.props.isEmployee) return "#f37335";
            return this.props.colorScale(match[0]['count']);
        }
        else if (this.props.isDetailedDistrict) {
            return "#818181";
        }
        else {
            if (!match[0]) return "#dbdbdb";
            if (match[0]['fips'] == this.props.stateFips && this.props.isEmployee) return "#f37335";
            const value = (!this.props.isEmployee) ? match[0][!this.props.isCongress ? 'total' : 'payment_amt'] : match[0]['count'];
            if (value === 0) return "#dbdbdb";
            return this.props.colorScale(value);
        }
    }

    render() {
        return (
            <g
                id={this.props.isEmployee ? 'empMap' : this.props.isDetailedDistrict ? 'ddMap' : ''}
            >
                {
                    this.props.shapeData.features.map((feature, i) => {
                        let hoverId = feature.properties.GEOID;
                        if (this.props.isCongress) {
                            console.log(feature.properties);
                            //e.g. output:
                            //{ STATEFP: '13', CD119FP: '07', GEOID: '1307', GEOIDFQ: '5001900US1307', NAMELSAD: 'Congressional District 7', …}
                            hoverId = feature.properties.STATEFP + feature.properties.CD119FP;
                        }
                        
                        const match =
                            this.props.data
                                .filter(d => (!this.props.isCongress)
                                    ? (!this.props.isEmployee)
                                        ? `${"0".repeat(5 - d["fips"].length)}${d["fips"]}` === hoverId
                                        : d['fips']==hoverId
                                    : d['congress_id'].padStart(4, '0') == hoverId.toString())
                        
                        return <GeoPath
                            $isClickable={!(this.props.isCongress && this.props.factSheet)}
                            stroke={this.props.isDetailedDistrict ? 'white' : this.props.isEmployee ? '#d4d4d4' : '#ccc'}
                            strokeWidth={this.props.isDetailedDistrict ? 2 : this.props.isEmployee?1.2:0.5}
                            id={`path-${hoverId}`}
                            d={this.props.getGeoPath(this.props.shapeData)(feature)}
                            fill={this.fill(match)}
                            onMouseEnter={this.props.handleMouseEnter(match, feature)}
                            onMouseLeave={this.props.handleMouseLeave}
                            onClick={this.props.handleClick(feature)}
                        />
                    })
                }

            </g>
        )
    }
}

export default Map;